<template>
  <main
    :class="{
      'product-stage': true,
      'detail-stage': true
    }"
    v-if="product && Object.keys(product).length > 0"
  >
  
  <router-link
      class="button-prev"
      :to="prevProduct"
      tabindex="6"
      v-if="products.length > 1 && !fromList"
      title="Vorheriges Produkt ansehen via Button"
      ><i class="icon-chevron-left" aria-hidden="true"></i
    ><span>Vorheriges Produkt ansehen</span></router-link>
    <router-link
      class="button-next"
      :to="nextProduct"
      tabindex="7"
      v-if="products.length > 1 && !fromList"
      title="Nächstes Produkt ansehen via Button"
      ><i class="icon-chevron-right" aria-hidden="true"></i
    ><span>Nächstes Produkt ansehen</span></router-link>
    
    
    <div class="pic-stage">
      <div class="container">
        <div
          class="bg"
          :style="{
            'background-image':
              product.background && product.background.length > 0
                ? 'url(' + product.background + ')'
                : 'none'
          }"
        >
          <div
            class="bg-blur"
            :style="{
              'background-image':
                product.image && product.image.length > 0
                  ? 'url(' + product.image + ')'
                  : 'none'
            }"
            v-if="!product.background || product.background.length <= 0"
          ></div>
          
          <img :src="product.image" :class="{ 'product-pic': true, portrait: product.portrait }" :alt="product.altText || `Verpackung der Feuerwerksartikel „${product.title}“ von Weco`" />
          
          <VideoPreview v-if="product.youtubeId" :previewUrl="videoPreviewPic" @open="openVideo" />
          
        </div>
      </div>
    </div>
    <div class="content" ref="content">
      
      <VideoPreview tabindex="5" v-if="product.youtubeId" :previewUrl="videoPreviewPic" @open="openVideo" />
      
      <div class="details">
        
        <div class="title-container">
          
          <div class="bonus-badge-image-container" v-if="product.bonusProdukt">
            <img src="/assets/images/bonus-badge-25euro.png" alt="25,00 € Bonus" class="bonus-badge-image" /> 
          </div>
          
          <h1 class="title-with-package-hint">
            <small v-if="product.categories">{{ product.categories[0] }}</small>
            <span>{{ product.title }}<sup><a tabindex="11" href="#fn1" id="fn1-link" aria-label="3, Fußnoten anzeigen" aria-describedby="footnote-label">3</a></sup></span>
          </h1>
        </div>

        <div class="row stats" v-if="hasStats">
          <div class="col" v-if="product.teile">
            <span class="visually-hidden">{{ `${product.teileUeber ? 'Über ' : ''}${product.teile} Teile` }}</span>
            <div class="label" aria-hidden="true">
              <strong><span v-if="product.teileUeber">Über&nbsp;</span
              >{{ product.teile }}</strong> Teile
            </div>
            <div class="bar" aria-hidden="true">
              <div
                class="filled"
                :style="`width:${getStatRelation('teile')}%`"
              ></div>
            </div>
          </div>
          <div class="col" v-if="product.schuss">
            <span class="visually-hidden">{{ `${product.schuss} Schuss` }}</span>
            <div class="label" aria-hidden="true">
              <strong>{{ product.schuss }}</strong> Schuss
            </div>
            <div class="bar" aria-hidden="true">
              <div
                class="filled"
                :style="`width:${getStatRelation('schuss')}%`"
              ></div>
            </div>
          </div>
          <div class="col" v-if="product.kaliber">
            <span class="visually-hidden">{{ `${product.kaliber} mm Kaliber` }}</span>
            <div class="label" aria-hidden="true">
              <strong>{{ product.kaliber }}mm</strong> Kaliber
            </div>
            <div class="bar" aria-hidden="true">
              <div
                class="filled"
                :style="`width:${getStatRelation('kaliber')}%`"
              ></div>
            </div>
          </div>
          <div class="col" v-if="product.effekthoehe">
            <span class="visually-hidden">{{ `${product.effekthoehe} m Effekthöhe` }}</span>
            <div class="label" aria-hidden="true">
              <strong>{{ product.effekthoehe }}m</strong> Effekthöhe
            </div>
            <div class="bar" aria-hidden="true">
              <div
                class="filled"
                :style="`width:${getStatRelation('effekthoehe')}%`"
              ></div>
            </div>
          </div>
          <div class="col" v-if="product.laenge">
            <span class="visually-hidden">{{ `${product.laenge} Sek. Effektdauer` }}</span>
            <div class="label" aria-hidden="true">
              <strong>{{ product.laenge }}&nbsp;Sek.</strong> Effektdauer
            </div>
            <div class="bar" aria-hidden="true">
              <div
                class="filled"
                :style="`width:${getStatRelation('laenge')}%`"
              ></div>
            </div>
          </div>
        </div>
        <div class="row add">
          <div class="col list-button" v-if="!fromList">
            <ShoppinglistAddButton :productNr="product.nr" :productTitle="product.title" :tabindex="25" />
          </div>
          <div class="col price">
            <PriceLabel 
              :price="parseFloat(product.price)" 
              :productData="product"
            />
          </div>
        </div>

        <h2>Über das Produkt</h2>
        <p v-if="product.copy" v-html="$options.filters.nl2br(product.copy)"></p>
        <button
          v-on:click.prevent="openSharePopup"
          class="share-button button-light"
          tabindex="30"
          aria-label="Produkt teilen"
          >Produkt teilen<img src="/assets/images/share-icon-black.png" alt="Icon teilen" />
      </button>

        <SharePopup
          v-if="openShare"
          :shareUrl="shareUrl"
          @close="closeSharePopup"
          :shoppinglist="false"
          :product="product"
        />
      </div>
      <aside aria-label="Weitere Produkte" class="related" v-if="relatedProducts.length > 0 && !fromList">
        <h3>Das könnte dir auch gefallen</h3>

        <ul>
          <li v-for="product in relatedProducts" :key="product.nr">
        <router-link
          
          :to="{
            name: 'product',
            params: { nr: product.nr, slug: product.slug }
          }"
          :aria-label="`${product.title} (${product.categories[0]}), ${product.price} € je Packung ansehen`"
        >
          <div
            class="pic"
            :style="{
              'background-image':
                product.thumb && product.thumb.length > 0
                  ? 'url(' + product.thumb + ')'
                  : 'none'
            }"
          ></div>

          <div class="details">
            <h4 class="title-with-package-hint">
              <small>{{ product.categories[0] }}</small>
              {{ product.title }}
            </h4>
          </div>
          <div class="meta">
            <PriceLabel 
              :price="parseFloat(product.price)" 
              :inline="false" 
              :productData="product"
            />
          </div>
        </router-link>
      </li>
        </ul>
      </aside>

      <FooterComponent :border="false" />
    </div>

  </main>
</template>

<script>
const randomIndex = max => Math.floor(Math.random() * max + 1);

import { mapState, mapGetters } from "vuex";
import ShoppinglistAddButton from "@/components/ShoppinglistAddButton.vue";
import PriceLabel from "@/components/PriceLabel.vue";
import FooterComponent from "@/components/Footer";
import SharePopup from "@/components/SharePopup";
import VideoPreview from "@/components/VideoPreview";
export default {
  name: "product",
  components: {
    ShoppinglistAddButton,
    PriceLabel,
    FooterComponent,
    SharePopup,
    VideoPreview
  },
  data() {
    return {
      productNr: false,
      relatedProducts: [],
      openShare: false,
      fromList: false
    };
  },
  metaInfo() {
    return {
      title: `${this.product.title} | ` || ""
    };
  },
  created() {},
  mounted: async function() {
    // if we come from a list, emit to App.vue that it should store the key
    // this changes the back button
    if (this.$route.query.list && this.$route.query.list !== "") {
      this.fromList = true;
      this.$emit("setSharelist", this.$route.query.list);
      this.$router.replace({
        name: "product",
        params: { nr: this.$route.params.nr, slug: this.$route.params.slug }
      });
    } else {
      this.$emit("setSharelist", false);
    }

    this.$store.commit("SET_SHOW_SCROLLBAR", false);
    this.productNr = this.$route.params.nr;
    await this.getProduct();
    
    // should we instantly open the video?
    if (this.$route.query && this.$route.query.openvideo === true) {
      this.openVideo()
      this.$router.replace({
        name: "product",
        params: { nr: this.$route.params.nr, slug: this.$route.params.slug }
      });
    }
    
    this.$trackPageView({ name: `:produktdetail:${this.product.title.replace('&', 'and').split(" ").join("-").toLowerCase()}`, hierarchy: ["produktdetail"] });
  },
  destroyed() {
    this.$store.commit("SET_SHOW_SCROLLBAR", true);
  },
  methods: {
    openSharePopup() {
      this.$trackCustomEvent('click_feuerwerk2025_produkt-teilen');
      this.openShare = true;
    },
    closeSharePopup() {
      this.openShare = false;
    },
    openVideo() {
      this.$trackVideoEvent(this.product.youtubeId, "Effektvideo zu "+this.product.title, "video_started");
      this.$emit("openVideo", this.product.youtubeId);
    },
    getProduct: async function() {
      await this.$store.dispatch("getProduct", this.productNr || false);
    },
    goToProduct(direction) {
      if (direction === "prev") {
      } else {
      }
    },
    setRelatedProducts() {
      // max count is 4, except we don't have enough products
      const maxCount =
        this.products.length - 1 < 4 ? this.products.length - 1 : 4;

      const items = []; // stores the related products

      // find current products index (if there)
      const thisProductIndex = this.products.findIndex(
        el => el.id === this.product.id
      );

      // make a copy of products (without the current products index)
      let tempProducts = this.products.slice(0);
      if (thisProductIndex) {
        tempProducts.splice(thisProductIndex, 1);
      }

      // loop through the temp products and pick random products for related
      while (items.length < maxCount && tempProducts.length > 0) {
        const i = randomIndex(tempProducts.length) - 1;
        const thisProduct = tempProducts[i];
        tempProducts.splice(i, 1);
        items.push(thisProduct);
      }

      this.relatedProducts = items;
    },
    getStatRelation(stat) {
      const maxVal = this.stats[stat];
      const val = this.product[stat];
      if (!maxVal || !val) return 0;
      let relation = Math.round((100 * val) / maxVal);
      if (relation >= 100) relation = 100;
      return relation;
    }
  },
  watch: {
    allLoaded(newVal) {
      if (newVal === true) {
        this.setRelatedProducts();
      }
    }
  },
  computed: {
    ...mapState(["stats", "pics"]),
    ...mapGetters(["products"]),
    hasStats() {
      return (
        this.product.teile ||
        this.product.schuss ||
        this.product.kaliber ||
        this.product.effekthoehe ||
        this.product.laenge
      );
    },
    shareUrl() {
      return window.location.href;
    },
    allLoaded() {
      return (
        this.products &&
        this.products.length > 0 &&
        this.product &&
        Object.keys(this.product).length > 0
      );
    },
    product() {
      return this.$store.getters.product(this.productNr);
    },
    productIndex() {
      return this.products.findIndex(el => el.nr === this.productNr);
    },
    prevProduct() {
      let returnIndex = 0;
      if (this.productIndex >= 0) {
        // we found this product in current array
        if (this.productIndex === 0) {
          returnIndex = this.products.length - 1;
        } else {
          returnIndex = this.productIndex - 1;
        }
      } else {
        // we havent found this product in current array
        returnIndex = this.products.length - 1;
      }
      return {
        name: "product",
        params: {
          nr: this.products[returnIndex].nr,
          slug: this.products[returnIndex].slug
        }
      };
    },
    nextProduct() {
      let returnIndex = 0;
      if (this.productIndex >= 0) {
        // we found this product in current array
        if (this.productIndex >= this.products.length - 1) {
          returnIndex = 0;
        } else {
          returnIndex = this.productIndex + 1;
        }
      } else {
        // we havent found this product in current array
        returnIndex = 0;
      }
      return {
        name: "product",
        params: {
          nr: this.products[returnIndex].nr,
          slug: this.products[returnIndex].slug
        }
      };
    },
    videoPreviewPic(){
      return this.product.previewGif || this.pics.headerPicDefault
    }
  },
};
</script>

<style lang="scss">
@import "./Product";
</style>
